import React, { useEffect, useState } from 'react';
import xhr from '../../utils/fetch';
import { useAppSelector } from '../../hooks/useRedux';
import { LPlan } from '../../typings/plan';
import { useParams } from 'react-router-dom';
import { PlanCard } from '../MyPlans/PlanCard';

function StudentPlans() {
  const { profile } = useAppSelector((state) => state.profileSlice);
  const { id } = useParams();
  const [plans, setPlans] = useState<LPlan[]>([]);
  const userData = profile;

  useEffect(() => {
    xhr({
      url: `/t/${userData?._id}/plans`,
      method: 'GET'
    }).then((res) => {
      if (res.status === 'OK') {
        const data = res.data.filter((plan: LPlan) => plan.userId === id);
        setPlans(data);
      }
    });
  }, []);

  return (
    <div className="w-full min-h-screen flex flex-col bg-neutralGray4 p-4">
      <div className="bg-white p-6">
        <h3 className="font-medium text-2xl py-4">{plans.length > 0 ? plans[0].user.name : 'Student'}'s Profile</h3>
        <div className="w-full flex flex-col gap-6">
          {plans.length > 0 ? plans.map((plan) => <PlanCard plan={plan} key={plan._id} />) : 'Not Found'}
        </div>
      </div>
    </div>
  );
}

export default StudentPlans;
